import React, { useContext, useEffect } from 'react';
import { Container, Row, Col } from 'reactstrap';
import * as Sentry from '@sentry/react';
import { useTranslation } from 'react-i18next';
import { clearTokenData } from '../../utils/helpers';
import { Store } from '../../Store';

const Logout = () => {
  const { dispatch } = useContext(Store);
  const { t } = useTranslation();

  useEffect(() => {
    dispatch({ type: 'CLEAR_STORE' });
    localStorage.removeItem('gh.i18n');
    clearTokenData();
    Sentry.configureScope((scope) => scope.setUser(null));
  }, []);

  return (
    <>
      <div
        className="header py-7 py-lg-8 pt-lg-9"
        style={{ height: '100vh', background: '#2dce89' }}
      >
        <Container>
          <div className="mb-7">
            <Row className="justify-content-center">
              <Col
                className="px-5"
                lg="6"
                md="8"
                xl="5"
                style={{ alignItems: 'center', display: 'flex', flex: 1, flexDirection: 'column' }}
              >
                <h1 className="text-white">{t('logout.title', 'Utloggad')}</h1>
                <p className="text-lead text-white">
                  {t(
                    'logout.text',
                    'Ni har nu blivit utloggade, vänligen använd er inloggnings-länk för att logga in på nytt'
                  )}
                </p>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Logout;
